import { render } from "./RestoreModal.vue?vue&type=template&id=74568522&scoped=true"
import script from "./RestoreModal.vue?vue&type=script&lang=js"
export * from "./RestoreModal.vue?vue&type=script&lang=js"

import "./RestoreModal.vue?vue&type=style&index=0&id=74568522&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74568522"],['__file',"src/components/RestoreModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74568522"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74568522', __exports__)) {
    api.reload('74568522', __exports__)
  }
  
  module.hot.accept("./RestoreModal.vue?vue&type=template&id=74568522&scoped=true", () => {
    api.rerender('74568522', render)
  })

}


export default __exports__